module.exports = __webpack_public_path__ + "img/shedro.b745e9c2.webp";